import { render, staticRenderFns } from "./AuctionValueColumn.vue?vue&type=template&id=a5cc6dd4&scoped=true&"
import script from "./AuctionValueColumn.vue?vue&type=script&lang=ts&"
export * from "./AuctionValueColumn.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionValueColumn.vue?vue&type=style&index=0&id=a5cc6dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc6dd4",
  null
  
)

export default component.exports